import { Currency } from "../store/root-reducers";

export const CURRENCIES: Currency[] = ["EUR", "USD", "GEL"]
export const API_TAX_RATE_URL = "https://nbg.gov.ge/gw/api/ct/monetarypolicy/currencies/en/json";
